import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/home.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about/index.vue'),
    meta:{
      title:'关于我们'
    }
  },
  {
    path: '/about/detail',
    name: 'aboutDetail',
    meta:{
      title:'关于我们'
    },
    component: () => import('../views/about/detail.vue')
  },
  {
    path: '/cemetery',
    name: 'cemetery',
    component: () => import('../views/cemetery/index.vue'),
    meta:{
      title:'生态节地葬'
    }
  },{
    path: '/cemetery/detail',
    name: 'cemetery-detail',
    component: () => import('../views/cemetery/detail.vue'),
    meta:{
      title:'生态节地葬'
    }
  },
  {
    path: '/contact-us',
    name: 'contactUs',
    meta:{
      title:'联系我们'
    },
    component: () => import('../views/contactUs.vue')
  },
  {
    path: '/service',
    name: 'service',
    meta:{
      title:'服务流程'
    },
    component: () => import('../views/service.vue')
  },
  {
    path: '/news',
    name: 'news',
    meta:{
      title:'古园动态'
    },
    component: () => import('../views/news/index.vue')
  },
  {
    path: '/news/detail',
    name: 'newsdetail',
    meta:{
      title:'古园动态'
    },
    component: () => import('../views/news/detail.vue')
  },
  {
    path: '/customer',
    name: 'customer',
    meta:{
      title:'客户服务'
    },
    component: () => import('../views/customer/index.vue')
  },
  {
    path: '/customer/detail',
    name: 'customerDetail',
    meta:{
      title:'客户服务'
    },
    component: () => import('../views/customer/detail.vue')
  },
  {
    path: '/commemorate',
    name: 'commemorate',
    meta:{
      title:'人文纪念'
    },
    component: () => import('../views/commemorate/index.vue')
  },
  {
    path: '/commemorate/list',
    name: 'commemorateList',
    meta:{
      title:'人文纪念'
    },
    component: () => import('../views/commemorate/list.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to,from,next) => {
  //同页面tabs切换，不回到顶部
  if(to.path!=from.path){
    window.scrollTo(0,0);
  }
})

export default router